export const CacheKeys = {
  USERS: 'users',
  PARENT_CHILD: 'parent_child',
  PROFILE: 'profile',
  SUBSCRIPTION_PLANS: 'subscription_plans',
  SUBSCRIPTION: 'subscription',
  TRANSACTIONS: 'transactions',
  LEADERBOARD: 'leaderboard',
  FULL_CHILD_PROFILE: 'full_child_profile',
  QUIZ_ATTEMPT: 'quiz_attempt',
};
